import { call, put, takeLatest } from "redux-saga/effects";

import {
  totalCountStart,
  totalCountSuccess,
  totalCountFailure,
} from "./totalCountSlice";

import { getTotalCountApi } from "./totalCountApi";

function* getTotalCountSaga(action) {
  try {
   // console.log("Calling API with payload:", action.payload);
    const params = action.payload;
    const response = yield call(getTotalCountApi, params);
    //console.log("Full API response:", response);
// console.log("response.data",response.data)
    if (response.data) {
     // console.log("response.data",response.data)
     // console.log("action.payload.tname",action.payload.tname)
      //console.log("About to dispatch totalCountSuccess with:", response.data);
      //yield put(totalCountSuccess(response));
  yield put(
  totalCountSuccess({
    ...response.data,
    meta: {
      collection: action.payload.tname ? action.payload.tname : action.payload.collection
    }
  })
);

    } else {
      // console.log("Dispatching failure due to response.success being false");
      // console.log("Error details:", response.error);
      yield put(totalCountFailure(response.error));
    }
  } catch (error) {
    //console.log("Caught error in getTotalCountSaga:", error);
    yield put(totalCountFailure(error.message));
  }
}

export function* watchTotalCount() {
  yield takeLatest(totalCountStart.type, getTotalCountSaga);
}
